import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    columnGap: "5rem",
    rowGap: "3rem",
    padding: "0 1rem",
  },
  shoppingBag: {
    flexGrow: 1,
    width: "42rem",
    display: "flex",
    flexDirection: "column",
  },
  summary: {
    flexGrow: 1,
    width: "24rem",
    position: "sticky",
    top: "3rem",
    alignSelf: "start",
  },
  continueBtn: {
    width: "max-content",
    padding: "0",
    marginBottom: "2rem",
    border: "none",
    background: "none",
    cursor: "pointer",
    textTransform: "uppercase",
    textDecoration: "underline",
    color: theme.darkSlateGrayColor,
    fontFamily: theme.fontFamilyArchivo,
    fontSize: "0.8rem",
    fontWeight: 600,
  },
  shoppingBagText: {
    fontSize: "1.5rem",
    fontWeight: 500,
    letterSpacing: "-1px",
    textTransform: "uppercase",
  },
  cart: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    marginTop: "1rem",
  },
  cartHeader: {
    display: "grid",
    gridTemplateColumns: "2.3fr 1fr 1fr 1fr",
    columnGap: "1rem",
    padding: "1rem 0",
    border: `1px solid ${theme.snowColor}`,
    borderRight: "none",
    borderLeft: "none",
    fontSize: "0.8rem",
    justifyItems: "right",
    textTransform: "capitalize",
    backgroundColor: theme.whiteColor,
  },
  quantityHeader: {
    gridColumn: "2",
  },
  priceHeader: {
    gridColumn: "3",
  },
  totalHeader: {
    gridColumn: "4",
  },
  cartItems: {
    display: "grid",
    rowGap: "1rem",
  },
  cartItem: {
    position: "relative",
    display: "grid",
    gridTemplateColumns: "2.3fr 1fr 1fr 1fr",
    gridTemplateRows: "minmax(4rem, max-content) max-content",
    columnGap: "1rem",
    gridColumn: "1 / span 4",
    gridRow: "1 / span 2",
    justifyItems: "right",
    paddingBottom: "1rem",
    borderBottom: `1px solid ${theme.snowColor}`,
    fontSize: "0.8rem",
  },
  info: {
    gridColumn: "1",
    gridRow: "1 / span 2",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    gap: "1rem",
    textDecoration: "none",
    color: "unset",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  image: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: `1px solid ${theme.snowColor}`,
    minWidth: "5rem",
    width: "5rem",
    minHeight: "5rem",
    height: "5rem",
    objectFit: "cover",
  },
  brandAndNameAndOption: {
    width: "100%",
    textAlign: "left",
  },
  brand: {
    fontWeight: 600,
  },
  name: {
    textTransform: "capitalize",
  },
  option: {
    "& > span:not(:last-child)": {
      marginRight: "0.2rem",
    },
    "& > span:not(:last-child)::after": {
      content: '" /"',
    },
  },
  quantity: {
    gridColumn: "2",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: "max-content",
    maxWidth: "5.5rem",
    minWidth: "5.5rem",
    gap: "0.1rem",
    borderRadius: "3px",
    border: `1px solid ${theme.snowColor}`,
  },
  removeOrAddBtn: {
    border: "none",
    background: "none",
    cursor: "pointer",
    padding: "0.5rem 0.7rem",
    color: theme.darkGrayColor,
    fontFamily: theme.fontFamilyArchivo,
    fontSize: "0.8rem",
  },
  price: {
    gridColumn: "3",
  },
  total: {
    gridColumn: "4",
    gridrow: "1",
  },
  summaryInner: {
    display: "flex",
    flexDirection: "column",
    height: "max-content",
    width: "100%",
    padding: "1rem",
    gap: "1rem",
    border: `1px solid ${theme.snowColor}`,
    borderRadius: "10px",
    fontSize: "0.8rem",
    textTransform: "uppercase",
    "& > div": {
      display: "flex",
      justifyContent: "space-between",
    },
  },
  estimatedTotal: {
    fontSize: "0.9rem",
    fontWeight: 500,
    textTransform: "capitalize",
  },
  checkoutBtn: (props: any) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "3.5rem",
    border: "none",
    textDecoration: "none",
    "& > button": {
      width: "100%",
      height: "100%",
      padding: 0,
      border: "none",
      borderRadius: "7px",
      color: props.isCartEmpty ? theme.darkGrayColor : theme.whiteColor,
      background: props.isCartEmpty
        ? theme.snowColor
        : `linear-gradient(to right, ${theme.blanchedAlmondColor}, ${theme.peachPuffColor})`,
      textTransform: "uppercase",
      fontSize: "0.9rem",
      fontWeight: 500,
      fontFamily: theme.fontFamilyArchivo,
      cursor: props.isCartEmpty ? "not-allowed" : "pointer",
    },
  }),
  horizontalLine: {
    borderBottom: `1px solid ${theme.snowColor}`,
  },
}));

export default useStyles;
